import { useEffect } from "react";

const DEFAULT_SITE_URL = "https://dev.auto.sites.ovizia.com";
export const siteUrl = String(process.env.REACT_APP_SITE_URL || DEFAULT_SITE_URL).replace(/\/+$/, "");

export const absoluteUrl = (path = "/") => {
  const value = String(path || "/").trim();
  if (/^https?:\/\//i.test(value)) return value;
  return `${siteUrl}${value.startsWith("/") ? value : `/${value}`}`;
};

const setMetaTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    document.head.appendChild(tag);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null) tag.setAttribute(key, String(value));
  });
};

const setLinkTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("link");
    document.head.appendChild(tag);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null) tag.setAttribute(key, String(value));
  });
};

export default function Seo({
  title,
  description,
  canonicalPath = "/",
  favicon = "",
  image = "",
  type = "website",
  noindex = false,
  structuredData = [],
}) {
  useEffect(() => {
    const nextTitle = title || "Auto Portal";
    const nextDescription = description || "Browse current vehicle inventory.";
    const canonicalUrl = absoluteUrl(canonicalPath);
    const faviconUrl = favicon ? absoluteUrl(favicon) : "";
    const imageUrl = image ? absoluteUrl(image) : "";
    const robots = noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large";
    const schemas = (Array.isArray(structuredData) ? structuredData : [structuredData]).filter(Boolean);

    document.title = nextTitle;
    setMetaTag('meta[name="description"]', { name: "description", content: nextDescription });
    setMetaTag('meta[name="robots"]', { name: "robots", content: robots });
    setLinkTag('link[rel="canonical"]', { rel: "canonical", href: canonicalUrl });
    if (faviconUrl) setLinkTag('link[rel="icon"]', { rel: "icon", href: faviconUrl });

    setMetaTag('meta[property="og:title"]', { property: "og:title", content: nextTitle });
    setMetaTag('meta[property="og:description"]', { property: "og:description", content: nextDescription });
    setMetaTag('meta[property="og:type"]', { property: "og:type", content: type });
    setMetaTag('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    if (imageUrl) setMetaTag('meta[property="og:image"]', { property: "og:image", content: imageUrl });
    setMetaTag('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    setMetaTag('meta[name="twitter:title"]', { name: "twitter:title", content: nextTitle });
    setMetaTag('meta[name="twitter:description"]', { name: "twitter:description", content: nextDescription });
    if (imageUrl) setMetaTag('meta[name="twitter:image"]', { name: "twitter:image", content: imageUrl });

    document.head.querySelectorAll('script[data-seo-json-ld="true"]').forEach((script) => script.remove());
    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoJsonLd = "true";
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [canonicalPath, description, favicon, image, noindex, structuredData, title, type]);

  return null;
}
